import type React from 'react'
import { Box } from '@mui/material'
import { useState } from 'react'

import { MakeshiftDrawer } from '~/shared/ui'
interface Props {
  sidebar?: React.JSX.Element | null
  toolbar?: React.JSX.Element | null
  collapseDisabled?: boolean
}

const InterfaceContent: React.FC<React.PropsWithChildren<Props>> = props => {
  const [collapseSidebar, setCollapseSidebar] = useState(false)
  const { sidebar, toolbar } = props

  const handleSidebarCollapse = () => {
    setCollapseSidebar(current => !current)
  }

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      {sidebar && (
        <Box
          sx={{
            height: '100%',
            width: collapseSidebar ? '5rem' : '20%',
            borderRight: '0.1rem solid',
            borderRightColor: 'divider',
            overflow: collapseSidebar ? undefined : 'auto',
          }}
        >
          <MakeshiftDrawer
            collapseDisabled={props.collapseDisabled}
            open={!collapseSidebar}
            handleSidebarCollapse={handleSidebarCollapse}
            sidebar={sidebar}
          />
        </Box>
      )}
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flex: 1,
          width: '80%',
          flexDirection: 'column',
        }}
      >
        {toolbar && (
          <Box sx={{ p: 1, pr: 3, borderBottom: '0.1rem solid', borderBottomColor: 'divider' }}>
            {toolbar}
          </Box>
        )}
        <Box sx={{ flex: 1, overflow: 'auto' }}>{props.children}</Box>
      </Box>
    </Box>
  )
}

export default InterfaceContent
